export default class GtagEvent {

    static purchase = (order): any => {
        const itemsList:any = [] ;
        order.shipments.forEach(shipment => {
            shipment.items.forEach(item => {
                const itemGTA = {
                    item_id: item.product.reference,
                    item_name: item.product.name,
                    item_brand:item.product.brand ? item.product.brand : "",
                    item_quantity: item.quantity,
                    currency: item.price.currency,
                    price: item.price.taxIncluded,
                }
                itemsList.push(itemGTA)
            })
        })
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: order.reference,
                value: order.totalPrice.taxIncluded,
                tax: order.totalPrice.taxAmount,
                shipping: order.shippingPrice.taxIncluded,
                currency: order.shippingPrice.currency,
                coupon: order.coupon ? order.coupon.name : "",
                items: itemsList
            }
        })
    };

    static beginCheckout = (cart): any => {
        const items: any = []
        cart.shipments.forEach(shipment => {
            shipment.items.forEach(item => {
                const itemGTA = {
                    item_id: item.product.reference,
                    item_name: item.product.name,
                    item_brand:item.product.brand ? item.product.brand : "",
                    item_quantity: item.quantity,
                    currency: item.price.currency,
                    price: item.price.taxIncluded,
                }
                items.push(itemGTA)
            })
        })
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
            event: "begin_checkout",
            ecommerce: {
                value: cart ? cart.totalPrice.taxIncluded : 0,
                currency:  cart ? cart.totalPrice.currency : "EUR",
                items
            }
        })
    };

    static viewCart = (cart): any => {
        const items: any = []
        cart.shipments.forEach(shipment => {
            shipment.items.forEach(item => {
                const itemGTA = {
                    item_id: item.product.reference,
                    item_name: item.product.name,
                    item_brand:item.product.brand ? item.product.brand : "",
                    item_quantity: item.quantity,
                    currency: item.price.currency,
                    price: item.price.taxIncluded,
                }
                items.push(itemGTA)
            })
        })
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
            event: "view_cart",
            ecommerce: {
                items,
                value: cart ? cart.totalPrice.taxIncluded : 0,
                currency:  cart ? cart.totalPrice.currency : "EUR",
            }
        })
    };

    static viewItem = (product, activeCategory, cart): any => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
                value: cart ? cart.totalPrice.taxIncluded : 0,
                currency:  cart ? cart.totalPrice.currency : "EUR",
                items: [{
                    affiliation:product.defaultOffer.shopName?product.defaultOffer.shopName:"",
                    item_id: product.reference,
                    item_name: product.name,
                    item_brand: product.brand ? product.brand : "",
                    item_category:activeCategory ? activeCategory : "",
                    currency: product.defaultOffer.price.currency,
                    price:product.defaultOffer.price.taxIncluded,
                    discount: product.defaultOffer.discountPrice.taxIncluded ? product.defaultOffer.discountPrice.taxIncluded : null,
                    quantity:1
                }]
            }
        })
    };

    static AddToCart = (product,qty, activeCategory, cart): any => {
        debugger
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                value: cart ? cart.totalPrice.taxIncluded : 0,
                currency:  cart ? cart.totalPrice.currency : "EUR",
                items: [{
                    affiliation:product.defaultOffer.shopName?product.defaultOffer.shopName:"",
                    item_id: product.reference,
                    item_name: product.name,
                    item_brand: product.brand ? product.brand : "",
                    item_category:activeCategory ? activeCategory : "",
                    currency: product.defaultOffer.price.currency,
                    price:product.defaultOffer.price.taxIncluded,
                    discount: product.defaultOffer.discountPrice.taxIncluded ? product.defaultOffer.discountPrice.taxIncluded : null,
                    quantity:qty
                }]
            }
        })
    };

    static RemoveToCart = (product, cart): any => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        try {
            window.dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    value: cart ? cart.totalPrice.taxIncluded : 0,
                    currency:  cart ? cart.totalPrice.currency : "EUR",
                    items: [{
                        affiliation: product.offer.shop.name ? product.offer.shop.name : "",
                        item_id: product.reference,
                        item_name: product.name,
                        currency: product.offer.regularPrice.currency,
                        price: product.offer.regularPrice.taxIncluded,
                        discount: product.offer.discountPrice.taxIncluded? product.offer.discountPrice.taxIncluded : null,
                    }]
                }
            })
        }catch (e){
            // console.error(e)
             }
    };

    static AddToCartShipment = (product,qty, cart): any => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                value: cart ? cart.totalPrice.taxIncluded : 0,
                currency:  cart ? cart.totalPrice.currency : "EUR",
                items: [{
                    affiliation: product.offer.shop.name ? product.offer.shop.name : "",
                    item_id: product.reference,
                    item_name: product.name,
                    currency: product.offer.regularPrice.currency,
                    price: product.offer.regularPrice.taxIncluded,
                    discount: product.offer.discountPrice.taxIncluded? product.offer.discountPrice.taxIncluded : null,
                    quantity:qty
                }]
            }
        })
    };

    static AddToCartLight = (product,qty, cart): any => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                value: cart ? cart.totalPrice.taxIncluded : 0,
                currency:  cart ? cart.totalPrice.currency : "EUR",
                items: [{
                    item_id: product.reference,
                    item_name: product.name,
                    item_brand: product.brand ? product.brand : "",
                    currency: product.price.currency,
                    price:product.price,
                    discount: product.discountPrice ? product.discountPrice : null,
                    quantity:qty
                }]
            }
        })
    };

    static search = (searchTerm): any => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "search",
            search_term: searchTerm

        })
    };

    static signUp = (): any => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "sign_up"
        })
    }
    static login = (): any => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "login"
        })
    }
}